import React from 'react';
import { withRouter } from 'react-router-dom';

class RelatorioContabilidade extends React.Component {

    constructor() {

        super();

        this.state = {
            disabled: false,
            centros:[],
            centro: "Centro",
            anos: [],
            ano: "Ano",
            mes: "Mês"
        };

        this.changeCentro = this.changeCentro.bind(this);
        this.changeAno = this.changeAno.bind(this);
        this.changeMes = this.changeMes.bind(this);
        this.voltar = this.voltar.bind(this);
        this.baixar = this.baixar.bind(this);

    }

    changeCentro(e) {

        let centro = e.target.value
        this.setState({ centro: centro });

        if (centro === "Centro") {

            this.setState({ anos: [] });
            this.setState({ ano: "Ano" });

        } else {

            fetch("/api/movimentacao/ano/" + centro, {
                method: "GET",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors"
            })
            .then(response => response.json())
            .then(responseJson => {

                this.setState({ anos: responseJson });

            });

        }

    }

    changeAno(e) {
        this.setState({ ano: e.target.value });
    }

    changeMes(e) {
        this.setState({ mes: e.target.value });
    }

    voltar() {
        this.props.history.push("/relatorios");
    }

    baixar() {

        this.setState({ disabled: true });

        if (this.state.centro === "Centro") {

            this.props.errMsgHandler("Por favor, informe o centro de custo das movimentações financeiras.");
            this.setState({ disabled: false });

        } else if (this.state.ano === "Ano") {

            this.props.errMsgHandler("Por favor, informe o ano das movimentações financeiras.");
            this.setState({ disabled: false });

        } else if (this.state.mes === "Mês") {

            this.props.errMsgHandler("Por favor, informe o mês das movimentações financeiras.");
            this.setState({ disabled: false });

        } else {

            this.props.errMsgHandler("");
            this.props.waitMsgHandler("Aguardando");

            let centro = this.state.centro;
            let ano = this.state.ano;
            let mes = this.state.mes;

            fetch("/api/movimentacao/existemov/" + centro + "/" + ano + "/" + mes, {
                method: "GET",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors"
            })
            .then(response => response.json())
            .then(responseJson => {

                if (responseJson.msg !== "success") {

                    this.props.waitMsgHandler("");
                    this.props.errMsgHandler(responseJson.msg);
                    this.setState({ disabled: false });

                } else {

                    let obj = {
                        "file_name": responseJson.file
                    };

                    fetch("/api/movimentacao/relatorio/contabilidade", {
                        method: "POST",
                        headers: {
                            "Content-type": "application/json",
                            "Authorization": "Basic " + btoa(localStorage.auth)
                        },
                        mode: "cors",
                        body: JSON.stringify(obj)
                    })
                    .then(response2 => response2.blob())
                    .then(blob => {

                        this.props.waitMsgHandler("");
                        this.setState({ disabled: false });

                        let url = window.URL.createObjectURL(blob);
                        let a = document.createElement("a");
                        a.href = url;
                        a.download = responseJson.file;
                        a.click();

                    });

                }

            });

        }

    }

    componentDidMount() {

        if (localStorage.roleRelatorios === "nenhuma") {
            window.location.href = "/home";
        }

        fetch("/api/centro/", {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.json())
        .then(responseJson => {

            this.setState({ centros: responseJson });

        });

    }

    render() {
        return(
            <div>
                <h1 id="relcontabilidade-title">
                    Relatório de Contabilidade
                </h1><br />
                <p id="relcontabilidade-txt">
                    Informe o centro de custo, o ano e o mês das movimentações financeiras.
                </p><br /><br />
                <form id="relcontabilidade-form">
                    <select value={ this.state.centro } onChange={ this.changeCentro }>
                        <option value="Centro">Centro</option>
                        { this.state.centros.map((item, i) =>
                            <option key={ i } value={ item.id }>{ item.nome }</option> ) }
                    </select><br />
                    <select value={ this.state.ano } onChange={ this.changeAno }>
                        <option value="Ano">Ano</option>
                        { this.state.anos.map((item, i) =>
                            <option key={ i } value={ item }>{ item }</option> ) }
                    </select><br />
                    <select value={ this.state.mes } onChange={ this.changeMes }>
                        <option value="Mês">Mês</option>
                        <option value="1">Janeiro</option>
                        <option value="2">Fevereiro</option>
                        <option value="3">Março</option>
                        <option value="4">Abril</option>
                        <option value="5">Maio</option>
                        <option value="6">Junho</option>
                        <option value="7">Julho</option>
                        <option value="8">Agosto</option>
                        <option value="9">Setembro</option>
                        <option value="10">Outubro</option>
                        <option value="11">Novembro</option>
                        <option value="12">Dezembro</option>
                    </select><br /><br />
                    <button type="button" id="relcontabilidade-voltar-btn" onClick={ this.voltar }>
                        Voltar
                    </button>
                    <button type="button"
                        id="relcontabilidade-baixar-btn"
                        onClick={ this.baixar }
                        disabled={ this.state.disabled }>
                        Baixar Relatório
                    </button>
                </form>
                <br /><br />
            </div>
        );
    }

}

export default withRouter(RelatorioContabilidade);

